import snsAxiosClient from '../common/http/http-sns';
import { get } from 'lodash';

function getAllPreferences(environmentVariables, user) {
  const options = {
    headers: {
      ...get(environmentVariables, 'API_HEADERS_GET_V1'),
      Authorization: `Bearer ${get(user, 'authToken')}`,
    },
  };
  return snsAxiosClient(options).get(
    `${get(environmentVariables, 'SNS_ALL_PREFERENCES')}${get(user, 'UUID')}/allPreferences`,
  );
}

export default getAllPreferences;
